import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'navigation-shortcuts.flags.set-pages-link-error.title',
		defaultMessage: "Something went wrong, but we're on it",
		description: '',
	},
	description: {
		id: 'navigation-shortcuts.flags.set-pages-link-error.description',
		defaultMessage:
			'In the meantime, refresh this page. Contact support if you keep getting this message.',
		description: '',
	},
});

const setPagesLinkErrorFlag = (): FlagConfiguration => ({
	type: 'error',
	title: messages.title,
	description: messages.description,
	isAutoDismiss: true,
	messageId: 'navigation-shortcuts.flags.set-pages-link-error',
	messageType: 'transactional',
});

export default setPagesLinkErrorFlag;
